import { bbkApiSlice } from '@bbkAdminRedux/rtkq/bbkApi.slice';

export enum ProductKey {
  AGS = 'AGS',
  DEFLECT = 'DEFLECT',
}

export type ProductLicense = {
  id: number;
  product_key: ProductKey;
  display_name: string;
};

export type ApplicationLicense = {
  active: boolean;
  id?: number;
  product_license: ProductLicense;
};

export const productSlice = bbkApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProductLicenses: builder.query<ProductLicense[], void>({
      query: () => `/dev/productLicenses`,
      providesTags: ['Products'],
    }),
  }),
});
